function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from "vue-property-decorator";
import DialogForm from "@/components/DialogForm/index.vue";
var ActionSetting = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(ActionSetting, Vue1);
    var _super = _createSuper(ActionSetting);
    function ActionSetting() {
        _classCallCheck(this, ActionSetting);
        var _this;
        _this = _super.apply(this, arguments);
        _this.dialog = {
            config: {
                title: "\u914D\u7F6E action \u57CB\u70B9",
                visible: false
            },
            value: {
                text: ""
            },
            itemList: [
                {
                    type: "input",
                    subtype: "textarea",
                    prop: "text",
                    params: {
                        placeholder: "\u8BF7\u8F93\u5165 action1-10 \u5185\u5BB9\uFF0C\u4E0D\u540C action \u8BF7\u7528\u6362\u884C\u7B26\u9694\u5F00\uFF0C\u7CFB\u7EDF\u4F1A\u6309\u7167\u5F55\u5165\u987A\u5E8F\u586B\u5145 action1-10\uFF0C\u8D85\u8FC7\u5219\u81EA\u52A8\u8FC7\u6EE4",
                        rows: 10
                    }
                }
            ]
        };
        return _this;
    }
    var _proto = ActionSetting.prototype;
    _proto.handleClick = function handleClick() {
        this.clearText();
        this.dialog.config.visible = true;
    };
    _proto.clearText = function clearText() {
        this.dialog.value.text = "";
    };
    _proto.autoFill = function autoFill() {
        this.fillAction(this.dialog.value.text);
        this.dialog.config.visible = false;
    };
    _proto.fillAction = function fillAction(text) {
        if (!text) return;
        var actionTextArray = text.split("\n");
        for(var i = 1; i <= 10; i++){
            this.formValue["action".concat(i)] = actionTextArray[i - 1] || "";
        }
    };
    return ActionSetting;
}(Vue);
__decorate([
    Prop({
        type: Object
    })
], ActionSetting.prototype, "formValue", void 0);
__decorate([
    Prop({
        type: Object
    })
], ActionSetting.prototype, "config", void 0);
ActionSetting = __decorate([
    Component({
        components: {
            DialogForm: DialogForm
        }
    })
], ActionSetting);
export { ActionSetting as default };
